import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isFunction } from '@cloud-sn/v-utils';
import { buildComponentName } from '../utils';
import { isImageUrl } from './utils';
import Icon from '../icon';
import Tooltip from '../tooltip';
import Progress from '../progress';
export default {
  name: buildComponentName('UploadList'),
  props: {
    prefixCls: {
      type: String,
      default: ''
    },
    listType: {
      type: String,
      default: 'text'
    },
    progressAttr: {
      type: Object,
      default: function _default() {
        return {
          strokeWidth: 2,
          hideInfo: true
        };
      }
    },
    showPreviewIcon: {
      type: Boolean,
      default: true
    },
    showRemoveIcon: {
      type: Boolean,
      default: true
    },
    showOperateIcon: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    locale: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    chunk: {
      type: Boolean,
      default: false
    },
    onPreview: {
      type: Function,
      default: null
    }
  },
  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          listType = this.listType;
      return _ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-list"), true), _defineProperty(_ref, "".concat(prefixCls, "-list-").concat(listType), true), _ref;
    }
  },
  methods: {
    onRemove: function onRemove(file, e) {
      e.preventDefault();
      this.$emit('remove', file, e);
    },
    onPause: function onPause(file, e) {
      e.preventDefault();
      e.stopPropagation();
      this.$emit('pause', file, e);
    },
    onRun: function onRun(file, e) {
      e.preventDefault();
      e.stopPropagation();
      this.$emit('run', file, e);
    },
    handlePreview: function handlePreview(file, e) {
      var onPreview = this.onPreview;

      if (!isFunction(onPreview)) {
        return;
      }

      e.preventDefault();
      onPreview(file, e);
    },
    renderList: function renderList() {
      var _this = this;

      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          list = this.list,
          listType = this.listType,
          locale = this.locale,
          showRemoveIcon = this.showRemoveIcon,
          showPreviewIcon = this.showPreviewIcon,
          progressAttr = this.progressAttr,
          handlePreview = this.handlePreview,
          onPause = this.onPause,
          onRun = this.onRun,
          onRemove = this.onRemove,
          chunk = this.chunk,
          showOperateIcon = this.showOperateIcon;
      return list.map(function (file) {
        var _cls;

        var uid = file.uid,
            name = file.name,
            status = file.status,
            thumbUrl = file.thumbUrl,
            url = file.url,
            linkProps = file.linkProps,
            fileError = file.error,
            response = file.response;
        var onBindPreview = handlePreview.bind(_this, file);
        var onBindRemove = onRemove.bind(_this, file);
        var onBindPause = onPause.bind(_this, file);
        var onBindRun = onRun.bind(_this, file);
        var icon = h(Icon, {
          "attrs": {
            "type": status === 'uploading' ? 'loading' : 'file'
          }
        });

        if (listType === 'picture' || listType === 'picture-card') {
          if (listType === 'picture-card' && status === 'uploading') {
            icon = h("div", {
              "class": "".concat(prefixCls, "-list-item-uploading-text")
            }, [locale.uploading]);
          } else if (!thumbUrl && !url) {
            icon = h(Icon, {
              "attrs": {
                "type": "picture"
              },
              "class": "".concat(prefixCls, "-list-item-thumbnail")
            });
          } else {
            var thumbnail = isImageUrl(file) ? h("img", {
              "attrs": {
                "src": thumbUrl || url,
                "alt": name
              }
            }) : h(Icon, {
              "attrs": {
                "type": "file"
              },
              "class": "".concat(prefixCls, "-list-item-icon")
            });
            icon = h("a", {
              "attrs": {
                "target": "_blank",
                "rel": "noopener noreferrer",
                "href": url || thumbUrl
              },
              "class": "".concat(prefixCls, "-list-item-thumbnail"),
              "on": {
                "click": onBindPreview
              }
            }, [thumbnail]);
          }
        }

        var opIcon = null;

        if (status !== 'success' && (showOperateIcon || chunk)) {
          opIcon = status === 'uploading' ? h(Icon, {
            "attrs": {
              "title": locale.pause,
              "type": "pause_circle_o"
            },
            "class": "".concat(prefixCls, "-list-item-op"),
            "on": {
              "click": onBindPause
            }
          }) : h(Icon, {
            "attrs": {
              "title": locale.run,
              "type": "play_circle_o"
            },
            "class": "".concat(prefixCls, "-list-item-op"),
            "on": {
              "click": onBindRun
            }
          });
        }

        var actions = showRemoveIcon ? h("span", {
          "class": "".concat(prefixCls, "-list-item-ops")
        }, [[opIcon, h(Icon, {
          "attrs": {
            "type": "close",
            "title": locale.removeFile
          },
          "on": {
            "click": onBindRemove
          }
        })]]) : null;

        if (listType === 'picture-card') {
          var cardActions = [];
          var previewIcon = null;

          if (status !== 'uploading') {
            var linkUrl = url || thumbUrl;
            previewIcon = showPreviewIcon ? h("a", {
              "attrs": {
                "rel": "noopener noreferrer",
                "target": "_blank",
                "title": locale.previewFile,
                "href": linkUrl
              },
              "style": linkUrl ? {} : {
                pointerEvents: 'none',
                opacity: 0.5
              },
              "on": {
                "click": onBindPreview
              }
            }, [h(Icon, {
              "attrs": {
                "type": "eye_o"
              }
            })]) : null;
            cardActions.push(previewIcon);
          }

          cardActions.push(showRemoveIcon ? h(Icon, {
            "attrs": {
              "type": "delete_o",
              "title": locale.removeFile
            },
            "on": {
              "click": onBindRemove
            }
          }) : null);
          actions = h("span", {
            "class": "".concat(prefixCls, "-list-item-actions")
          }, [cardActions]);
        }

        var preview = url || thumbUrl ? h("a", _mergeJSXProps([{}, {
          class: "".concat(prefixCls, "-list-item-name"),
          attrs: _objectSpread({}, linkProps, {
            href: url || thumbUrl,
            target: '_blank',
            rel: 'noopener noreferrer',
            title: name
          }),
          on: {
            click: onBindPreview
          }
        }]), [name]) : h("span", {
          "class": "".concat(prefixCls, "-list-item-name"),
          "attrs": {
            "title": name
          },
          "on": {
            "click": onBindPreview
          }
        }, [name]);
        var cls = (_cls = {}, _defineProperty(_cls, "".concat(prefixCls, "-list-item"), true), _defineProperty(_cls, "".concat(prefixCls, "-list-item-").concat(file.status === 'pause' ? 'uploading' : file.status), true), _cls);
        var message = fileError && fileError.message || locale.uploadError;

        if (response && typeof response === 'string') {
          message = response;
        }

        var progress = null;

        if (status === 'uploading' || status === 'pause') {
          progress = h("div", {
            "key": "progress",
            "class": "".concat(prefixCls, "-list-item-progress")
          }, ['percent' in file ? h(Progress, {
            "props": _objectSpread({}, _objectSpread({}, progressAttr, {
              percentage: file.percent
            }))
          }) : null]);
        }

        var infoNode = h("span", [icon, preview]);
        return h("div", {
          "key": uid,
          "class": cls
        }, [h("div", {
          "class": "".concat(prefixCls, "-list-item-info")
        }, [status === 'error' ? h(Tooltip, {
          "attrs": {
            "content": message
          }
        }, [infoNode]) : infoNode]), actions, progress]);
      });
    }
  },
  render: function render() {
    var h = arguments[0];
    var classes = this.classes,
        renderList = this.renderList;
    return h("div", {
      "class": classes
    }, [renderList()]);
  }
};